import {
  Box,
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography
} from '@mui/material';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login } from '../../store/slices/authSlice';
import { User } from '../../types';

const LoginPage: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedUser, setSelectedUser] = useState('');

  // デモ用のユーザーリスト
  const demoUsers: User[] = [
    {
      id: '1',
      name: '田中 太郎',
      email: 'tanaka@company.com',
      role: 'admin',
    },
    {
      id: '2',
      name: '佐藤 花子',
      email: 'sato@company.com',
      role: 'user',
    },
    {
      id: '3',
      name: '山田 次郎',
      email: 'yamada@company.com',
      role: 'user',
    },
  ];

  const handleLogin = () => {
    const user = demoUsers.find(u => u.id === selectedUser);
    if (user) {
      // ローカルストレージに保存（デモ用）
      localStorage.setItem('demoUser', JSON.stringify(user));
      dispatch(login(user));
      navigate('/');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            全社ナレッジ共有システム
          </Typography>
          <Typography variant="h6" gutterBottom align="center" color="text.secondary">
            ログイン
          </Typography>

          <Box sx={{ mt: 3 }}>
            <FormControl fullWidth sx={{ mb: 3 }}>
              <InputLabel>ユーザーを選択</InputLabel>
              <Select
                value={selectedUser}
                label="ユーザーを選択"
                onChange={(e) => setSelectedUser(e.target.value)}
              >
                {demoUsers.map((user) => (
                  <MenuItem key={user.id} value={user.id}>
                    {user.name} ({user.role === 'admin' ? '管理者' : 'ユーザー'})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={handleLogin}
              disabled={!selectedUser}
              sx={{ mt: 2 }}
            >
              ログイン
            </Button>
          </Box>

          <Box sx={{ mt: 4, p: 2, bgcolor: 'info.main', borderRadius: 1 }}>
            <Typography variant="body2" color="white" gutterBottom>
              <strong>デモ機能について</strong>
            </Typography>
            <Typography variant="caption" color="white">
              • 管理者（田中 太郎）：.vttファイルアップロード機能にアクセス可能<br />
              • ユーザー（佐藤 花子、山田 次郎）：インサイト閲覧のみ
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default LoginPage;
